import { FC, useEffect, useMemo, useState } from "react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Divider,
  Heading,
  SimpleGrid,
  Input,
  VStack,
  Image,
  Center,
  CircularProgress,
  Text,
  Container,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { Field, Form } from "react-final-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  CustomInput,
  DownloadFile,
  CustomCheckbox,
  CustomSelect,
  CustomMultiSelect,
} from "../../customComponents/components";
import { PageHead } from "../../home/components/PageHead";
import { CardsBlock } from "../../editUser/components/CardsBlock";
import {
  DonwloadComponent,
  DonwloadComponentNew,
} from "../../customComponents/components/CustomInput/CustomInput";
import moment from "moment";
import { API_URL } from "../../httpClient/constants";
import { useVehicleList } from "../../vehicle/hooks";
import { useArticleData, useArticleSet } from "../hooks";

export const PromoblockSetScreen = () => {
  const { promoblock_id } = useParams();
  const toast = useToast();
  const { vehiclesList } = useVehicleList();
  const { articleSetReq, articleSetLoading } = useArticleSet();
  const { articleData, articleDataLoading, getArticleData } =
    useArticleData(promoblock_id);

  const onSubmit = async (values: any) => {
    console.log("onSubmit", values);
    // const vIds = values?.vehicle_id?.map((v) => v.value);
    if (!values.vehicle_id) {
      delete values.vehicle_id;
    }
    const res = await articleSetReq({ ...values });
    if (res?.success) {
      toast({
        title: "промоблок создан",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      getArticleData(promoblock_id);
    } else {
      toast({
        title: "возникла ошибка",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  // const vIdsSaved = useMemo(() => {
  //   //@ts-ignore
  //   if (articleData?.vehicle_id) {
  //     //@ts-ignore
  //     const vIdParsed = articleData?.vehicle_id?.split(",");
  //     console.log("vIdParsed", vIdParsed);
  //     console.log("vehiclesList", vehiclesList);
  //     return vehiclesList
  //       ?.filter((v) => vIdParsed.includes(v.id.toString()))
  //       ?.map((v) => {
  //         return {
  //           value: v.id,
  //           label: v.title,
  //         };
  //       });
  //   }
  //   return [];
  // }, [articleData, vehiclesList]);

  if (articleSetLoading || articleDataLoading) {
    return (
      <Container height="calc(100vh - 240px)">
        <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
      </Container>
    );
  }
  // console.log("vIdsSaved", vIdsSaved);
  return (
    <>
      <Form
        mutators={{
          setValue: ([field, value], state, { changeValue }) => {
            changeValue(state, field, () => value);
          },
        }}
        onSubmit={onSubmit}
        // validate={() => true}
        initialValues={{
          ...articleData,
          text:
            //@ts-ignore
            articleData?.text === "null" || articleData?.text === "undefined"
              ? ""
              : //@ts-ignore
                articleData?.text,
          vehicle_id:
            //@ts-ignore
            articleData?.vehicle_id === "null" ||
            //@ts-ignore
            articleData?.vehicle_id === "undefined"
              ? ""
              : //@ts-ignore
                articleData?.vehicle_id,
        }}
        render={({ form, handleSubmit, values }) => {
          return (
            <Box boxShadow="lg" p="6" rounded="md" bg="white">
              <Flex justify="space-between">
                <Breadcrumb
                  spacing="8px"
                  separator={<ChevronRightIcon color="gray.500" />}
                >
                  <BreadcrumbItem>
                    <BreadcrumbLink as={Link} to="/promoblock">
                      Промоблоки
                    </BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink href="#">
                      {promoblock_id ? promoblock_id : "Новый промоблок"}
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Flex>
              <Divider marginTop={"20px"} marginBottom={"20px"} />
              <Box width="100%">
                <Heading size={"md"}>
                  {promoblock_id
                    ? "Редактировать промоблок"
                    : "Создать промоблок"}
                </Heading>
                <Divider marginTop={"20px"} marginBottom={"20px"} />
                <Field
                  name="text"
                  placeholder={"Заголовок"}
                  label={"Заголовок"}
                  // pattern={pattern}
                  component={CustomInput}
                />
                <div style={{ height: 20 }} />
                <DonwloadComponentNew
                  name={"image"}
                  intialPreview={values["image"]}
                  label={"Главное изображение"}
                  multiple={false}
                  fullwidth={false}
                />
                <div style={{ height: 20 }} />
                <DonwloadComponentNew
                  name={"video"}
                  intialPreview={values["video"]}
                  label={"Видео"}
                  multiple={false}
                  fullwidth={false}
                />
                <div style={{ height: 20 }} />
                <p>
                  При указании внешней ссылки - будет открываться она, чтобы
                  промоблок открывал автомобиль, оставьте это поле пустым, и
                  выберите автомобиль из списка ниже
                </p>
                <Field
                  name="link"
                  placeholder={"Внешняя ссылка"}
                  label={"Внешняя ссылка"}
                  // pattern={pattern}
                  component={CustomInput}
                />
                <div style={{ height: 20 }} />
                {/* <DonwloadComponent
                  label={'Превью изображение'}
                  name='image'
                  // srcPic={destructure(name, values)}
                  url={API_URL}
                  onClick={() => {
                    handleLink(name, values);
                  }}
                  disabled={isDisabled(name, values)}
                /> */}
                {/* <div style={{ height: 20 }} />
                <Field
                  name="reading_time"
                  placeholder={"Время на прочтение"}
                  label={"Время на прочтение"}
                  // pattern={pattern}
                  component={CustomInput}
                /> */}
                <Field
                  name="vehicle_id"
                  placeholder={"Автомобиль"}
                  label={"Автомобиль"}
                  // pattern={pattern}
                  options={vehiclesList?.map((v) => {
                    return {
                      id: v.id,
                      label: v.title,
                    };
                  })}
                  // multiple
                  component={CustomSelect}
                />
                <div style={{ height: 20 }} />
                <Button onClick={handleSubmit}>Сохранить</Button>
              </Box>
            </Box>
          );
        }}
      />
    </>
  );
};
